// extracted by mini-css-extract-plugin
export default {"testBox":"LORf4m0YK912wxtI8QQn"};